import { MenuItem } from "@/features/auth/auth.interface";

export interface MenuTreeNode extends MenuItem {
  children: MenuTreeNode[];
}

export function buildMenuTree(flatMenu: MenuItem[]): MenuTreeNode[] {
  const menuMap = new Map<number, MenuTreeNode>();
  const rootItems: MenuTreeNode[] = [];

  // Crear nodos iniciales
  flatMenu.forEach(item => {
    menuMap.set(item.id, {
      ...item,
      children: [],
    });
  });

  // Construir relaciones jerárquicas
  flatMenu.forEach(item => {
    const node = menuMap.get(item.id)!;

    if (item.parent_id === null) {
      rootItems.push(node);
    } else {
      const parent = menuMap.get(item.parent_id);
      if (parent) {
        parent.children.push(node);
      }
    }
  });

  // Función de orden
  const sortFn = (a: MenuTreeNode, b: MenuTreeNode) => a.id - b.id;

  // Ordenar recursivamente
  const sortRecursive = (nodes: MenuTreeNode[]) => {
    nodes.sort(sortFn);
    nodes.forEach(node => {
      if (node.children.length > 0) {
        sortRecursive(node.children);
      }
    });
  };

  sortRecursive(rootItems);
  return rootItems;
}